<template>
  <div class="show">
    <!-- <el-container class="el-container" v-wechat-title="$route.meta.title"> -->
    <!-- <el-header class="el-header" height=".56rem" v-show="route !== '404'"> -->
      <HeaderComponent  v-show="$route.path !== '/404'"/>
    <!-- </el-header> -->
    <!-- <el-main class="el-main"> -->
      <router-view></router-view>
      <FooterComponent v-show="$route.path !== '/404'"/>
      <ToTop/>
    <!-- </el-main> -->
  <!-- </el-container> -->
  </div>
</template>

<script>
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import ToTop from "@/components/ToTopComponent.vue";
export default {
  name: "app",
  data() {
    return {
      route: sessionStorage.route
    };
  },
  components: {
    HeaderComponent,
    FooterComponent,
    ToTop,
  },
  created() {
    this.$vlf.config({
      name: "ag-web",
      version: 1.0,
      description: "acegear官网"
    });
  },
  updated() {
    this.route = sessionStorage.route;
  }
};
</script>

<style lang="scss" scoped>
.show{
  width: 19.2rem;
  margin: 0 auto;
  overflow: hidden;
}
.el-container {
  height: 100%;
}
.el-header {
  padding: 0;
}
.el-main {
  padding: 0;
  height: 100%;
}
</style>
